const Songs = {
	
	name: 'Songs',
	model: {

		idProperty: 'songs__id',
		displayProperty: 'songs__file',
		
		properties: [
			{ name: 'songs__id',	mapping: 'id',	type: 'int', },
			{ name: 'songs__file',	mapping: 'file', },
			{ name: 'songs__is_alt',	mapping: 'is_alt',	type: 'bool', defaultValue: false },
			{ name: 'songs__is_gated',	mapping: 'is_gated', type: 'bool', defaultValue: false, },
			{ name: 'songs__novox',	mapping: 'novox',	type: 'bool', defaultValue: false },
			{ name: 'songs__question_id',	mapping: 'question_id',	type: 'int', },
			{ name: 'songs__title',	mapping: 'title', },
			{ name: 'songs__is_gated',	mapping: 'isGated',	type: 'bool',	defaultValue: false, }, // put there by controller, based on purchased items
		
			{ name: 'questions__id',	mapping: 'question.id',	type: 'int', },
			{ name: 'questions__display_as',	mapping: 'question.display_as', },
			{ name: 'questions__q',	mapping: 'question.q', },
			{ name: 'questions__a',	mapping: 'question.a', },
			{ name: 'questions__next',	mapping: 'question.next',	type: 'int', },
			{ name: 'questions__prev',	mapping: 'question.prev',	type: 'int', },
			{ name: 'questions__next_in_full',	mapping: 'question.next_in_full',	type: 'int', },
			{ name: 'questions__sort_order',	mapping: 'question.sort_order',	type: 'int', },
			{ name: 'questions__division_id',	mapping: 'question.division_id',	type: 'int', },
			{ name: 'questions__volume_id',	mapping: 'question.volume_id',	type: 'int', },
			{ name: 'questions__ordinal',	mapping: 'question.ordinal', },
		],

		associations: {

			hasMany: [
				'Events'
			],
			belongsTo: [
				'Questions'
			],
			belongsToMany: [
				'Groups'
			],

		},

	},

	entity: {
		methods: {

			// This one has been modded to return objects of a particular signature
			getEvents: function() {
				const Events = this.getAssociatedRepository('Events'),
					eventEntities = Events.getBy((event) => {
						return event.events__song_id === this.songs__id;
					});
				return eventEntities.map((event) => {
					return {
						time: event.events__time,
						data: event.events__data,
						type: event.events__event_type_id,
					};
				});
			},

			getQuestion: function() {
				const Questions = this.getAssociatedRepository('Questions');
				return Questions.getById(this.songs__question_id);
			},
			
			getSiblings: function() {
				return this.getQuestion().getSongs();
			},

		},
	},

	repository: {
		type: 'lfr',
		local: {
			type: 'async',
			isPaginated: false,
			autoSave: true,
			methods: {
				getVoxSong: function(question, is_alt = false) {
					return this.getFirstBy((song) => {
						return song.songs__question_id === question.id && !song.songs__novox && song.songs__is_alt === is_alt;
					});
				},
				getNovoxSong: function(question, is_alt = false) {
					return this.getFirstBy((song) => {
						return song.songs__question_id === question.id && song.songs__novox && song.songs__is_alt === is_alt;
					});
				},
				getNonGated: function() {
					return this.getBy((song) => {
						return !song.songs__is_gated && !song.songs__novox && !song.songs__is_alt;
					});
				},
			},
		},
		remote: {
			type: 'onebuild',
			isPaginated: false,
			autoSave: false,
		},
	},

};

export default Songs;
